exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avatar[data-v-37ea112f] {\n  margin: 0.7rem 1rem;\n  color: #aaa9a9;\n}\n.avatar img[data-v-37ea112f] {\n  border-radius: 50%;\n  height: 10rem;\n  width: 10rem;\n}\n#profile_photo[data-v-37ea112f] {\n  display: none;\n}\n.button[data-v-37ea112f] {\n  width: 145px;\n}\n", ""]);

// exports
